export const replaceDashesWithSpaces = (inputString) => {
    return inputString.replace(/-/g, ' ');
}